import { observer } from 'mobx-react-lite';
import { withDefaultProps } from 'react-default-props-context';
import { ReferenceT } from 'src/api/types/ReferenceT';
import { cn } from 'src/frames/utils/cn';
import './ReferenceView.scss';

type PropsT = {
  className?: any;
  reference: ReferenceT;
};

type DefaultPropsT = {};

export const ReferenceView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    return (
      <div className={cn('ReferenceView', 'mb-3')}>
        {props.reference.url ? (
          <a
            className={cn('ReferenceView__Link')}
            href={props.reference.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.reference.text}
          </a>
        ) : (
          props.reference.text
        )}
      </div>
    );
  })
);
